import React from 'react';
import { Form, Button, Icon, TextArea, Message, Search } from 'semantic-ui-react';
import { DateInput } from 'semantic-ui-calendar-react';
import _ from 'lodash';
import storeArray from '../utilities/storeList';

import styled from 'styled-components';
import { ErrorMessage, Field } from 'formik';

import FormikInputField from '../componentsFormik/FormikInputField';

const RedText = styled.p`
  color: red;
  animation: fadein 1s;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

// const SLabel = styled.label`
//   display: inline-block;
//   margin-bottom: 0.5rem !important;
// `;

const STextArea = styled(TextArea)`
  margin-bottom: 1rem !important;
`;

const initialState = { isLoading: false, results: [] };

const storeList = storeArray.map(store => {
  const parsedStore = JSON.parse(store);
  return {
    title: parsedStore.store,
    description: parsedStore.address
  }
})

class AQPreviousJobs extends React.Component<any, any> {
  state = initialState;


  navigate = (
    step: number | string,
    backStep: (null | number | string) = null,
    percent: (null | number) = null,
    motivation: (null | string) = null,
    e: any,
    props?: any,
    validate?: boolean
  ) => {
    e.preventDefault();
    this.props.gaEvent('event', 'AdditionalQuestionsSubmit', 'Next', 'Boots', this.props.isValid);
    this.props.manualStep(step, backStep, percent, motivation, props, validate);
  };

  handleResultSelect = (e: object, vals: any) => {
    const { title, description } = vals.result;
    this.props.setFieldValue('aq_prevBranchName', title);
    this.props.setFieldValue('aq_prevBranchAddress', description);

  };

  handleSearchChange = (e: object, vals: any) => {
    const { value } = vals;
    this.setState({ isLoading: true });
    this.props.setFieldValue('aq_prevBranchName', value);

    setTimeout(() => {
      const val = this.props.values.aq_prevBranchName
      if (val < 1) {
        this.props.setFieldValue('aq_prevBranchName', '');
        return this.setState(initialState);
      };

      const re = new RegExp(val, 'i');
      const isMatch = (result: any) => { return re.test(result.title) || re.test(result.description) };

      this.setState({
        isLoading: false,
        results: _.filter(storeList, isMatch).slice(0, 4)
      })
    }, 500);
  }

  render() {
    const { isLoading, results } = this.state;
    return (
      <React.Fragment>

        <FormikInputField
          name="aq_prevJobTitle"
          type="input"
          label="Previous Job Title"
          placeholder=""
        />

        <Form.Group grouped>
          <DateInput
            label="Date When Previous Position Started"
            id="aq_prevDateStarted"
            clearable
            clearIcon={<Icon name="remove" color="red" />}
            name="aq_prevDateStarted"
            value={this.props.values.aq_prevDateStarted}
            onChange={(e, { name, value }) => {
              this.props.setFieldValue(name, value);
            }}
            onBlur={this.props.handleBlur}
            placeholder="dd/mm/yyyy"
            dateFormat="DD/MM/YYYY"
            animation={'fade'}
            autoComplete="off"
            closable={true}
            startMode="year"
            popupPosition="bottom center"
            hideMobileKeyboard={true}
          />
          <ErrorMessage
            name={'aq_prevDateStarted'}
            render={msg => <RedText className="error"> {msg} </RedText>}
          />
        </Form.Group>

        <Form.Group grouped>
          <DateInput
            label="Date When Previous Position Ended"
            id="aq_prevDateEnded"
            clearable
            clearIcon={<Icon name="remove" color="red" />}
            name="aq_prevDateEnded"
            value={this.props.values.aq_prevDateEnded}
            onChange={(e, { name, value }) => {
              this.props.setFieldValue(name, value);
            }}
            onBlur={this.props.handleBlur}
            placeholder="dd/mm/yyyy"
            dateFormat="DD/MM/YYYY"
            animation={'fade'}
            autoComplete="off"
            closable={true}
            startMode="year"
            popupPosition="bottom center"
            hideMobileKeyboard={true}
          />
          <ErrorMessage
            name={'aq_prevDateEnded'}
            render={msg => <RedText className="error"> {msg} </RedText>}
          />
        </Form.Group>

        <FormikInputField
          name="aq_prevJobCode"
          type="input"
          label="Previous Job Code"
          placeholder=""
        />

        <Form.Group grouped>
          <label>What Boots store did you previously work at?</label>
          <Search
            input={{ fluid: true }}
            fluid
            loading={isLoading}
            name="aq_prevBranchName"
            placeholder="Manchester"
            onResultSelect={this.handleResultSelect}
            onSearchChange={this.handleSearchChange}
            results={results}
            value={this.props.values.aq_prevBranchName}
          />
        </Form.Group>

        <FormikInputField
          name="aq_prevBranchNumber"
          type="input"
          label="Previous Branch Number (if known)"
          placeholder=""
        />

        <FormikInputField
          name="aq_prevHourlyPay"
          type="input"
          label="Previous Hourly Pay"
          placeholder=""
        />

        <FormikInputField
          name="aq_prevHoursPerWeek"
          type="input"
          label="Previous Hours Worked Per Week"
          placeholder=""
        />

        <Field
          name="aq_additionalInfo"
          render={({ field, form: { touched, errors } }: any) => (
            <React.Fragment>
              {/* <SLabel>Additional Information</SLabel> */}
              <Message info>
                <Message.Header>Additional Information</Message.Header>
                <p>
                  Please use the space below to tell us about any other jobs
                  (other than the ones you have already told us about),
                  or to provide other information about how your job title or
                  branch location changed in the last 6 years.
                </p>
                <p>
                  Bear in mind that we can only claim for the jobs that you tell us about.
                </p>
                <p>
                  You do not need to tell us about any jobs you held more than 6 years ago.
                </p>
              </Message>
              <STextArea {...field} placeholder='Tell us more...' style={{ minHeight: 200 }} />
            </React.Fragment>
          )}
        />

        <Button.Group widths="2">
          <Button
            labelPosition="left"
            floated="left"
            color="grey"
            icon="left chevron"
            content="Back"
            onClick={(e) => { this.navigate(this.props.backStep, null, null, null, e, this.props, true) }}
          />
          <Button
            labelPosition="right"
            floated="right"
            color={this.props.isValid ? 'green' : 'grey'}
            icon="right chevron"
            content='Submit'
            onClick={(e) => {
              this.navigate('FINALLY', null, null, null, e, this.props, true);
            }}
          />
        </Button.Group>
      </React.Fragment>
    );
  }
}

export default AQPreviousJobs;
